import {
  INICIA_MATRICULA,
  NOVO_MATRICULA,
  BUSCA_MATRICULA_EDICAO,
  CANCELA_EDICAO,
  INICIO_MATRICULA_SUCESSO,
  SALVA_MATRICULA_SUCESSO,
  REMOVE_MATRICULA_SUCESSO,
  BUSCA_MATRICULA_EDICAO_SUCESSO,
  INIT_URL,
  HIDE_MESSAGE,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  ON_SHOW_SUCCESS_MESSAGE,
  ON_SHOW_ERROR_MESSAGE,
  SHOW_MESSAGE,
  ALTERACAO_CAMPO,
  ALTERACAO_COMBO,
  ALTERACAO_DATEPICKER,
  ALTERACAO_CHECK,
  ALTERACAO_CAMPO_MASCARA_DATE,
  APLICA_FILTRO,
  LISTA_MATRICULA,
  LISTA_MATRICULA_SUCESSO,
  LIMPAR_MATRICULA,
  LISTA_ESCOLAS_MATRICULA_SUCESSO,
  LISTA_CURSOS_POR_ESCOLA_MATRICULA_SUCESSO,
  LISTA_SERIES_POR_CURSO_MATRICULA_SUCESSO,
  LISTA_TURMAS_POR_SERIE_MATRICULA_SUCESSO,
  LISTA_ALUNOS_MATRICULA_SUCESSO,
  LISTA_ANOS_LETIVOS_POR_ESCOLA_MATRICULA_SUCESSO,
  MATRICULA_OCORRENCIA_MODAL_OPEN,
  MATRICULA_OCORRENCIA_MODAL_CLOSE,
  LISTA_MATRICULA_OCORRENCIAS_SUCESSO,
  SALVA_MATRICULA_OCORRENCIA_SUCESSO,
  REMOVE_MATRICULA_OCORRENCIA_SUCESSO,
  LISTA_TIPOS_OCORRENCIA_SUCESSO,
  MATRICULA_TRANSFERENCIA_MODAL_OPEN,
  MATRICULA_TRANSFERENCIA_MODAL_CLOSE,
  MATRICULA_TRANSFERENCIA_MODAL_ATUALIZA_CAMPO,
  MATRICULA_TRANSFERENCIA_SALVAR,
  MATRICULA_TRANSFERENCIA_CANCELAR,
  MATRICULA_DISPENSA_MODAL_OPEN,
  MATRICULA_DISPENSA_MODAL_OPEN_SUCESSO,
  MATRICULA_DISPENSA_MODAL_CLOSE,
  MATRICULA_DISPENSA_MODAL_ATUALIZA_CAMPO,
  MATRICULA_DISPENSA_SALVAR,
  MATRICULA_DISPENSA_SALVAR_SUCESSO,
  MATRICULA_DISPENSA_REMOVER,
  MATRICULA_DISPENSA_REMOVER_SUCESSO,
  LISTA_TIPOS_DISPENSA_SUCESSO,
  LISTA_DISPENSAS_MATRICULA_SUCESSO,
  LISTA_COMPONENTES_ESCOLA_DISPENSA_SUCESSO,
  LISTA_PERIODOS_ANO_LETIVO_DISPENSA_SUCESSO,
  MATRICULA_DISPENSA_BUSCA_MATRICULA_SUCESSO
} from "constants/ActionTypes";
import { dateMask } from 'luxFw/transformations/Mascaras';

const normalizeMatriculaListItem = (m) => {
  const id = m.id || m.Id || 0;
  const alunoNome = m.alunoNome || m.AlunoNome || m.aluno || m.Aluno || '';
  const escolaNome = m.escolaNome || m.EscolaNome || '';
  const cursoNome = m.cursoNome || m.CursoNome || '';
  const serieNome = m.serieNome || m.SerieNome || '';
  const turmaNome = m.turmaNome || m.TurmaNome || '';
  const ano = m.ano || m.Ano || '';
  const situacao = m.situacao || m.Situacao || '';
  const formando = !!(m.formando || m.Formando || false);
  const dataMatricula = m.dataMatricula || m.DataMatricula || '';
  return { ...m, id, alunoNome, escolaNome, cursoNome, serieNome, turmaNome, ano, situacao, formando, dataMatricula };
};

const INIT_STATE = {
  colunasGrid: [
    { titulo: 'Código', propriedadeApi: 'id', alinhamento: 'left' },
    { titulo: 'Aluno', propriedadeApi: 'alunoNome', alinhamento: 'left' },
    { titulo: 'Escola', propriedadeApi: 'escolaNome', alinhamento: 'left' },
    { titulo: 'Curso', propriedadeApi: 'cursoNome', alinhamento: 'left' },
    { titulo: 'Série', propriedadeApi: 'serieNome', alinhamento: 'left' },
    { titulo: 'Turma', propriedadeApi: 'turmaNome', alinhamento: 'left' },
    { titulo: 'Ano', propriedadeApi: 'ano', alinhamento: 'left' },
    { titulo: 'Situação', propriedadeApi: 'situacao', alinhamento: 'left', renderBadge: true },
    { titulo: 'Data matrícula', propriedadeApi: 'dataMatricula', alinhamento: 'left' },
    { titulo: 'Formando', propriedadeApi: 'formando', alinhamento: 'left', booleano: true }
  ],

  loader: false,
  alertMessage: '',
  showMessageSuccess: false,
  showMessageError: false,
  edicao: false,
  carregandoLista: true,
  listGrid: [],
  listGridComFiltro: [],
  textoFiltro: '',
  matriculaCarregada: null,
  falecidoModalOpen: false,
  falecidoModalData: null,
  falecimentoLoading: false,
  deixouFrequentarModalOpen: false,
  deixouFrequentarModalData: null,
  deixouFrequentarLoading: false,
  reclassificacaoModalOpen: false,
  reclassificacaoModalData: null,
  reclassificacaoLoading: false,

  ocorrenciasModalOpen: false,
  ocorrenciasDaMatricula: [],
  listaTiposOcorrencia: [],

  dispensaModalOpen: false,
  dispensaModalData: null,
  dispensaLoading: false,
  dispensasDaMatricula: [],
  listaTiposDispensa: [],
  listaComponentesEscolaDispensa: [],
  listaPeriodosAnoLetivoDispensa: [],

  id: 0,
  ano: '',
  alunoId: null,
  escolaId: null,
  cursoId: null,
  serieId: null,
  turmaId: null,
  dataMatricula: '',
  dataSaida: '',
  formando: false,
  observacoes: '',
  situacao: '',
  code: '',

  listaEscolas: [],
  listaCursosPorEscola: [],
  listaSeriesPorCurso: [],
  listaTurmasPorSerie: [],
  listaAlunos: [],
  listaAnosLetivosPorEscola: [],
  // Filtros avançados
  escolaFiltro: null,
  cursoFiltro: null,
  serieFiltro: null,
  turmaFiltro: null,
  alunoFiltro: null,
  anoFiltro: '',
  nomeMatriculaFiltro: '',
  textoFiltro: '',

  // Paginação e Ordenação Servidor
  page: 1,
  perPage: 10,
  orderBy: '',
  orderDirection: 'asc',
  totalRecords: 0
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case INICIA_MATRICULA: {
      return { ...state, edicao: false, loader: true, carregandoLista: true };
    }
    case NOVO_MATRICULA: {
      return {
        ...state,
        edicao: true,
        loader: false,
        id: 0,
        ano: '',
        alunoId: null,
        escolaId: null,
        cursoId: null,
        serieId: null,
        turmaId: null,
        dataMatricula: '',
        formando: false,
        observacoes: '',
        situacao: '',
        code: '',
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false,
      };
    }
    case BUSCA_MATRICULA_EDICAO: {
      return { ...state, loader: true };
    }
    case CANCELA_EDICAO: {
      return { ...state, edicao: false };
    }
    case INICIO_MATRICULA_SUCESSO: {
      const retorno = action.payload || [];
      const lista = Array.isArray(retorno) ? retorno : (Array.isArray(retorno?.matriculas) ? retorno.matriculas : []);
      const totalRecords = retorno?.totalRecords || retorno?.TotalRecords || lista.length;
      const listaNorm = Array.isArray(lista) ? lista.map(normalizeMatriculaListItem) : [];
      return { ...state, loader: false, carregandoLista: false, listGrid: listaNorm, listGridComFiltro: listaNorm, totalRecords };
    }
    case SALVA_MATRICULA_SUCESSO: {
      return { ...state, loader: false, alertMessage: action.payload, showMessageSuccess: true, edicao: false };
    }
    case REMOVE_MATRICULA_SUCESSO: {
      return { ...state, loader: false, alertMessage: action.payload, showMessageSuccess: true, edicao: false };
    }
    case LISTA_MATRICULA: {
      const { page, perPage, orderBy, orderDirection } = action.payload || {};
      return {
        ...state,
        loader: true,
        carregandoLista: true,
        page: page !== undefined ? page : state.page,
        perPage: perPage !== undefined ? perPage : state.perPage,
        orderBy: orderBy !== undefined ? orderBy : state.orderBy,
        orderDirection: orderDirection !== undefined ? orderDirection : state.orderDirection
      };
    }
    case APLICA_FILTRO: {
      const texto = action.payload || '';
      return { ...state, textoFiltro: texto };
    }
    case LISTA_MATRICULA_SUCESSO: {
      const retorno = action.payload;
      const lista = Array.isArray(retorno) ? retorno : (Array.isArray(retorno?.matriculas) ? retorno.matriculas : []);
      const totalRecords = retorno?.totalRecords || retorno?.TotalRecords || lista.length;
      const listaNorm = Array.isArray(lista) ? lista.map(normalizeMatriculaListItem) : [];
      return { ...state, loader: false, carregandoLista: false, listGrid: listaNorm, listGridComFiltro: listaNorm, totalRecords };
    }
    case LISTA_ESCOLAS_MATRICULA_SUCESSO: {
      const escolasRaw = action.payload?.escolas || action.payload || [];
      const listaEscolas = Array.isArray(escolasRaw)
        ? escolasRaw.map(e => ({ id: e.id || e.Id, title: e.nome || e.Nome }))
        : [];
      return { ...state, listaEscolas };
    }
    case LISTA_CURSOS_POR_ESCOLA_MATRICULA_SUCESSO: {
      const cursosRaw = action.payload?.cursos || action.payload || [];
      const listaCursosPorEscola = Array.isArray(cursosRaw)
        ? cursosRaw.map(c => {
          const id = c.id || c.Id || c.cursoId || c.CursoId || 0;
          const nome = c.nome || c.cursoNome || c.descricao || c.Descricao || c.titulo || c.Titulo || '';
          const title = String(nome || id || '');
          return { id, title };
        })
        : [];
      return { ...state, listaCursosPorEscola };
    }
    case LISTA_SERIES_POR_CURSO_MATRICULA_SUCESSO: {
      const seriesRaw = action.payload?.series || action.payload || [];
      const listaSeriesPorCurso = Array.isArray(seriesRaw)
        ? seriesRaw.map(s => {
          const id = s.id || s.Id || s.serieId || s.SerieId || 0;
          const nome = s.nome || s.Nome || s.descricao || s.Descricao || s.titulo || s.Titulo || '';
          const title = String(nome || id || '');
          const idadeIdeal = s.idadeIdeal || s.IdadeIdeal || s.idade_ideal || null;
          const idadeInicial = s.idadeInicial || s.IdadeInicial || s.idade_inicial || null;
          const idadeFinal = s.idadeFinal || s.IdadeFinal || s.idade_final || null;
          const alertaFaixaEtaria = !!(s.alertaFaixaEtaria || s.AlertaFaixaEtaria || s.alerta_faixa_etaria);
          return { id, title, idadeIdeal, idadeInicial, idadeFinal, alertaFaixaEtaria };
        })
        : [];
      return { ...state, listaSeriesPorCurso };
    }
    case LISTA_TURMAS_POR_SERIE_MATRICULA_SUCESSO: {
      const turmasRaw = action.payload?.turmas || action.payload || [];
      const listaTurmasPorSerie = Array.isArray(turmasRaw)
        ? turmasRaw.map(t => {
          const id = t.id || t.Id || t.turmaId || t.TurmaId || 0;
          const nome = t.nome || t.Nome || t.descricao || t.Descricao || t.titulo || t.Titulo || '';
          const title = String(nome || id || '');
          const maxAluno = t.maxAluno || t.MaxAluno || t.capacidade || null;
          const alunosMatriculados = t.alunosMatriculados || t.AlunosMatriculados || t.matriculados || t.qtdMatriculados || null;
          return { id, title, maxAluno, alunosMatriculados };
        })
        : [];
      return { ...state, listaTurmasPorSerie };
    }
    case LISTA_ALUNOS_MATRICULA_SUCESSO: {
      const alunosRaw = action.payload?.alunos || action.payload || [];
      const listaAlunos = Array.isArray(alunosRaw)
        ? alunosRaw.map(a => {
          const id = a.id || a.Id || 0;
          const title = a.pessoaNome || a.Nome || '';
          const dataNascimentoStr = a.pessoaDataNascimento || a.dataNascimentoStr || a.data_nascimento || null;
          const usuarioPlataforma = a.usuarioPlataforma || a.UsuarioPlataforma || null;
          let dataNasc = dataNascimentoStr;
          if (!dataNasc && usuarioPlataforma) {
            dataNasc = usuarioPlataforma.dataNascimentoStr || usuarioPlataforma.dataNascimentoFormatada || null;
          }
          return { id, title, dataNascimentoStr: dataNasc };
        })
        : [];
      return { ...state, listaAlunos };
    }
    case LISTA_ANOS_LETIVOS_POR_ESCOLA_MATRICULA_SUCESSO: {
      const anosRaw = action.payload?.anosLetivos || action.payload || [];
      const listaAnosLetivosPorEscola = Array.isArray(anosRaw)
        ? anosRaw.map(a => {
          const anoVal = a.ano != null ? a.ano : (a.Ano != null ? a.Ano : (a.descricao || a.Descricao || a.id || a.Id || ''));
          const status = a.status || a.Status || '';
          const title = String(anoVal || '');
          return { id: anoVal, title, status };
        })
        : [];
      return { ...state, listaAnosLetivosPorEscola };
    }
    case LIMPAR_MATRICULA: {
      return {
        ...state,
        escolaFiltroMatricula: null,
        cursoFiltroMatricula: null,
        serieFiltroMatricula: null,
        turmaFiltroMatricula: null,
        alunoFiltroMatricula: null,
        anoFiltroMatricula: '',
        nomeMatriculaFiltro: '',
        textoFiltro: ''
      };
    }
    case BUSCA_MATRICULA_EDICAO_SUCESSO: {
      const retorno = action.payload;
      const base = retorno && retorno.matricula ? retorno.matricula : retorno;
      return {
        ...state,
        edicao: true,
        loader: false,
        matriculaCarregada: base,
        id: base.id || base.Id || 0,
        ano: base.ano || base.Ano || '',
        alunoId: base.alunoId || base.aluno_id || base.AlunoId || null,
        escolaId: base.escolaId || base.escola_id || base.EscolaId || null,
        cursoId: base.cursoId || base.curso_id || base.CursoId || null,
        serieId: base.serieId || base.serie_id || base.SerieId || null,
        turmaId: base.turmaId || base.turma_id || base.TurmaId || null,
        dataMatricula: base.dataMatricula || base.DataMatricula || '',
        dataSaida: base.dataSaida || base.DataSaida || '',
        formando: !!(base.formando || base.Formando || false),
        observacoes: base.observacoes || base.Observacoes || '',
        situacao: base.situacao || base.Situacao || '',
        code: base.code || base.Code || ''
      };
    }
    case 'matricula_falecido_modal_open': {
      const idMatricula = action.payload || state.id || 0;
      const base = state.matriculaCarregada || {};
      const alunoId = base.alunoId || base.aluno_id || base.AlunoId || null;
      const alunoNome = base.alunoNome || base.AlunoNome || '';
      return {
        ...state,
        falecidoModalOpen: true,
        falecidoModalData: { matriculaId: idMatricula, alunoId, alunoNome, data_cancel: '', observacao: '' },
        falecimentoLoading: false
      };
    }
    case 'matricula_falecido_modal_close': {
      return { ...state, falecidoModalOpen: false, falecidoModalData: null, falecimentoLoading: false };
    }
    case 'matricula_falecido_modal_atualiza_campo': {
      const { name, value } = action.payload || {};
      const cur = state.falecidoModalData || {};
      const next = { ...cur, [name]: value };
      return { ...state, falecidoModalData: next };
    }
    case 'matricula_falecimento_loading_on': {
      return { ...state, falecimentoLoading: true };
    }
    case 'matricula_falecimento_loading_off': {
      return { ...state, falecimentoLoading: false };
    }
    case 'matricula_deixou_modal_open': {
      const idMatricula = action.payload || state.id || 0;
      const base = state.matriculaCarregada || {};
      const alunoId = base.alunoId || base.aluno_id || base.AlunoId || null;
      const alunoNome = base.alunoNome || base.AlunoNome || '';
      return {
        ...state,
        deixouFrequentarModalOpen: true,
        deixouFrequentarModalData: {
          matriculaId: idMatricula,
          alunoId,
          alunoNome,
          id_tipo_abandono: null,
          deixou_de_frequentar_idade_obrigatoria: false,
          data_cancel: '',
          observacao: ''
        },
        deixouFrequentarLoading: false
      };
    }
    case 'matricula_deixou_modal_close': {
      return { ...state, deixouFrequentarModalOpen: false, deixouFrequentarModalData: null, deixouFrequentarLoading: false };
    }
    case 'matricula_deixou_modal_atualiza_campo': {
      const { name, value } = action.payload || {};
      const cur = state.deixouFrequentarModalData || {};
      const next = { ...cur, [name]: value };
      return { ...state, deixouFrequentarModalData: next };
    }
    case 'matricula_deixou_loading_on': {
      return { ...state, deixouFrequentarLoading: true };
    }
    case 'matricula_deixou_loading_off': {
      return { ...state, deixouFrequentarLoading: false };
    }
    case 'matricula_reclassificacao_modal_open': {
      const idMatricula = action.payload || state.id || 0;
      const base = state.matriculaCarregada || {};
      const alunoId = base.alunoId || base.aluno_id || base.AlunoId || null;
      const alunoNome = base.alunoNome || base.AlunoNome || '';
      return {
        ...state,
        reclassificacaoModalOpen: true,
        reclassificacaoModalData: {
          matriculaId: idMatricula,
          alunoId,
          alunoNome,
          id_curso: null,
          id_serie: null,
          id_turma: null,
          data_cancel: '',
          descricao_reclassificacao: ''
        },
        reclassificacaoLoading: false
      };
    }
    case 'matricula_reclassificacao_modal_close': {
      return { ...state, reclassificacaoModalOpen: false, reclassificacaoModalData: null, reclassificacaoLoading: false };
    }
    case 'matricula_reclassificacao_modal_atualiza_campo': {
      const { name, value } = action.payload || {};
      const cur = state.reclassificacaoModalData || {};
      const next = { ...cur, [name]: value };
      return { ...state, reclassificacaoModalData: next };
    }
    case 'matricula_reclassificacao_loading_on': {
      return { ...state, reclassificacaoLoading: true };
    }
    case 'matricula_reclassificacao_loading_off': {
      return { ...state, reclassificacaoLoading: false };
    }
    case MATRICULA_TRANSFERENCIA_MODAL_OPEN: {
      return {
        ...state,
        transferenciaModalOpen: true,
        transferenciaModalData: action.payload || {} // Aceita payload (visualizar) ou vazio (novo)
      };
    }
    case MATRICULA_TRANSFERENCIA_MODAL_CLOSE: {
      return { ...state, transferenciaModalOpen: false, transferenciaModalData: null, transferenciaLoading: false };
    }
    case MATRICULA_TRANSFERENCIA_MODAL_ATUALIZA_CAMPO: {
      const { name, value } = action.payload || {};
      const cur = state.transferenciaModalData || {};
      const next = { ...cur, [name]: value };
      return { ...state, transferenciaModalData: next };
    }
    case 'matricula_transferencia_loading_on': {
      return { ...state, transferenciaLoading: true };
    }
    case 'matricula_transferencia_loading_off': {
      return { ...state, transferenciaLoading: false };
    }
    case MATRICULA_OCORRENCIA_MODAL_OPEN: {
      const idMatricula = action.payload || state.id || 0;
      const base = state.matriculaCarregada || {};
      const ocorrencias = Array.isArray(base.ocorrenciasDisciplinares) ? base.ocorrenciasDisciplinares.map(o => ({
        id: o.id || o.Id || 0,
        id_tipo_ocorrencia_disciplinar: o.id_tipo_ocorrencia_disciplinar || o.tipoId || o.TipoId || null,
        tipoNome: o.tipoNome || o.TipoNome || o.tipo || '',
        data_ocorrencia: o.data_ocorrencia || o.DataOcorrencia || '',
        matriculaId: idMatricula,
      })) : [];
      return { ...state, ocorrenciasModalOpen: true, ocorrenciasDaMatricula: ocorrencias };
    }
    case MATRICULA_OCORRENCIA_MODAL_CLOSE: {
      return { ...state, ocorrenciasModalOpen: false };
    }
    case LISTA_MATRICULA_OCORRENCIAS_SUCESSO: {
      const listaRaw = action.payload || [];
      const idMatricula = state.id || 0;
      const tipos = Array.isArray(state.listaTiposOcorrencia) ? state.listaTiposOcorrencia : [];
      const lista = Array.isArray(listaRaw)
        ? listaRaw.map(o => {
          const id = o.id || o.Id || 0;
          const tipoId = o.id_tipo_ocorrencia_disciplinar || o.tipoId || o.TipoId || o.tipoOcorrenciaDisciplinarId || o.TipoOcorrenciaDisciplinarId || null;
          const tipo = tipos.find(t => String(t.id || t.Id) === String(tipoId));
          const tipoNome = tipo ? (tipo.nm_tipo || tipo.nome || tipo.Nome || tipo.title || '') : (o.tipoNome || o.TipoNome || o.tipo || o.nome || o.Nome || '');
          const rawDate = o.data_ocorrencia || o.DataOcorrencia || o.data || o.dataOcorrencia || o.Data || '';
          let dataFmt = rawDate;
          if (/^\d{4}-\d{2}-\d{2}/.test(rawDate)) {
            const y = rawDate.substr(0, 4);
            const m = rawDate.substr(5, 2);
            const d = rawDate.substr(8, 2);
            dataFmt = `${d}/${m}/${y}`;
          }
          return {
            id,
            id_tipo_ocorrencia_disciplinar: tipoId,
            tipoNome,
            data_ocorrencia: dataFmt,
            matriculaId: idMatricula,
          };
        })
        : [];
      return { ...state, ocorrenciasDaMatricula: lista };
    }
    case SALVA_MATRICULA_OCORRENCIA_SUCESSO: {
      const item = action.payload;
      let lista = [...state.ocorrenciasDaMatricula];
      const idx = lista.findIndex(x => x.id === item.id);
      if (idx >= 0) lista[idx] = item; else lista = [item, ...lista];
      return { ...state, ocorrenciasDaMatricula: lista };
    }
    case REMOVE_MATRICULA_OCORRENCIA_SUCESSO: {
      const id = action.payload;
      const lista = state.ocorrenciasDaMatricula.filter(x => x.id !== id);
      return { ...state, ocorrenciasDaMatricula: lista };
    }
    case LISTA_TIPOS_OCORRENCIA_SUCESSO: {
      const listaRaw = action.payload || [];
      const lista = Array.isArray(listaRaw)
        ? listaRaw.map(t => ({
          id: t.id || t.Id || 0,
          nm_tipo: t.nm_tipo || t.nome || t.Nome || t.title || '',
          descricao: t.descricao || t.Descricao || '',
          max_ocorrencias: (t.max_ocorrencias ?? t.maxOcorrencias ?? t.MaxOcorrencias ?? null),
        }))
        : [];
      return { ...state, listaTiposOcorrencia: lista };
    }
    case SHOW_MESSAGE: {
      return { ...state, alertMessage: action.payload, showMessageSuccess: false, showMessageError: true };
    }
    case HIDE_MESSAGE: {
      return { ...state, alertMessage: '', showMessageSuccess: false, showMessageError: false };
    }
    case ALTERACAO_CAMPO: {
      return { ...state, [action.payload.target.name]: action.payload.target.value };
    }
    case ALTERACAO_COMBO: {
      const valorBruto = action.payload.valor;
      const valorNormalizado = (valorBruto && typeof valorBruto === 'object')
        ? (valorBruto.id !== undefined ? valorBruto.id : (valorBruto.value !== undefined ? valorBruto.value : valorBruto))
        : valorBruto;
      const chave = action.payload.nomeCombo;
      return { ...state, [chave]: valorNormalizado };
    }
    case ALTERACAO_CHECK: {
      const retorno = action.payload;
      const chave = retorno.nomeCheck !== undefined ? retorno.nomeCheck : retorno.name;
      const valor = retorno.valor !== undefined ? retorno.valor : retorno.value;
      return { ...state, [chave]: valor };
    }
    case ALTERACAO_DATEPICKER: {
      const nome = action.payload.name;
      const valor = action.payload.value !== undefined ? action.payload.value : action.payload.date;
      return { ...state, [nome]: valor };
    }
    case ALTERACAO_CAMPO_MASCARA_DATE: {
      return { ...state, [action.payload.target.name]: dateMask(action.payload.target.value) };
    }
    case ON_SHOW_SUCCESS_MESSAGE: {
      return { ...state, alertMessage: action.payload, showMessageSuccess: true, showMessageError: false };
    }
    case ON_SHOW_ERROR_MESSAGE: {
      return { ...state, alertMessage: action.payload, showMessageSuccess: false, showMessageError: true };
    }
    case ON_HIDE_LOADER: {
      return { ...state, loader: false };
    }
    case ON_SHOW_LOADER: {
      return { ...state, loader: true };
    }
    case MATRICULA_DISPENSA_MODAL_OPEN: {
      return {
        ...state,
        dispensaModalOpen: false,
        dispensaLoading: true,
        dispensaModalData: {
          matriculaId: action.payload,
          tipoDispensaId: null,
          nomeTipoDispensa: '',
          observacoes: '',
          idsComponentesEscola: [],
          idsPeriodosAnoLetivo: []
        }
      };
    }
    case MATRICULA_DISPENSA_MODAL_OPEN_SUCESSO: {
      return { ...state, dispensaModalOpen: true, dispensaLoading: false };
    }
    case MATRICULA_DISPENSA_MODAL_CLOSE: {
      return { ...state, dispensaModalOpen: false, dispensaModalData: null, dispensaLoading: false };
    }
    case MATRICULA_DISPENSA_MODAL_ATUALIZA_CAMPO: {
      const { name, value } = action.payload || {};
      const cur = state.dispensaModalData || {};
      const next = { ...cur, [name]: value };
      return { ...state, dispensaModalData: next };
    }
    case MATRICULA_DISPENSA_SALVAR: {
      return { ...state, dispensaLoading: true };
    }
    case MATRICULA_DISPENSA_SALVAR_SUCESSO: {
      return { ...state, dispensaLoading: false, dispensaModalOpen: false, dispensaModalData: null };
    }
    case MATRICULA_DISPENSA_REMOVER: {
      return { ...state, dispensaLoading: true };
    }
    case MATRICULA_DISPENSA_REMOVER_SUCESSO: {
      return { ...state, dispensaLoading: false };
    }
    case LISTA_TIPOS_DISPENSA_SUCESSO: {
      return { ...state, listaTiposDispensa: Array.isArray(action.payload) ? action.payload : [] };
    }
    case LISTA_DISPENSAS_MATRICULA_SUCESSO: {
      return { ...state, dispensasDaMatricula: Array.isArray(action.payload) ? action.payload : [] };
    }
    case LISTA_COMPONENTES_ESCOLA_DISPENSA_SUCESSO: {
      return { ...state, listaComponentesEscolaDispensa: Array.isArray(action.payload) ? action.payload : [] };
    }
    case LISTA_PERIODOS_ANO_LETIVO_DISPENSA_SUCESSO: {
      return { ...state, listaPeriodosAnoLetivoDispensa: Array.isArray(action.payload) ? action.payload : [] };
    }
    case MATRICULA_DISPENSA_BUSCA_MATRICULA_SUCESSO: {
      const d = Array.isArray(action.payload) ? action.payload[0] : (action.payload || {});
      if (!d || (typeof d === 'object' && Object.keys(d).length === 0)) return state;
      const cur = state.dispensaModalData || {};
      return {
        ...state,
        dispensaModalData: {
          ...cur,
          id: d.id ?? d.Id ?? 0,
          tipoDispensaId: d.tipoDispensaId ?? d.TipoDispensaId ?? null,
          nomeTipoDispensa: d.nomeTipoDispensa ?? d.NomeTipoDispensa ?? '',
          observacoes: d.observacoes ?? d.Observacoes ?? '',
          idsComponentesEscola: Array.isArray(d.idsComponentesEscola) ? d.idsComponentesEscola : (Array.isArray(d.IdsComponentesEscola) ? d.IdsComponentesEscola : []),
          idsPeriodosAnoLetivo: Array.isArray(d.idsPeriodosAnoLetivo) ? d.idsPeriodosAnoLetivo : (Array.isArray(d.IdsPeriodosAnoLetivo) ? d.IdsPeriodosAnoLetivo : [])
        }
      };
    }
    default:
      return state;
  }
};
